import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files
import translationDE from './locales/de.json';
import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';
import translationAR from './locales/ar.json';

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  },
  ar: {
    translation: translationAR
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Default language is German
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

